import React, { createContext, useContext, useMemo, useState } from 'react'

import { useManageFieldRelationships } from '../hooks/useManageFieldRelationships'
import { useManageOptionRelationships } from '../hooks/useManageOptionRelationships'
import { useManageField } from '../hooks/useManageFields'
import { useManageSelectOptions } from '../hooks/useManageSelectOptions'

const OptionsRelationshipsContext = createContext(null)

export const SelectOptionsProvider = ({ children }) => {
  const [editingOption, setEditingOption] = useState({})
  const [showViewRelationshipsPopover, setShowViewRelationshipsPopover] = useState(null)
  const [showManageRelationshipsPopover, setShowManageRelationshipsPopover] = useState(null)

  const { fields, selectedFieldId: fieldId } = useManageField()

  const { fieldRelationships } = useManageFieldRelationships({ fieldId })

  const { options, updateOption, removeOption } = useManageSelectOptions()

  const { optionRelationships, manageSelectOptionRelationship } = useManageOptionRelationships({ fieldId })

  const relatedFieldIds = useMemo(() => {
    return Object.keys(fieldRelationships || {})
      .map((fieldId) => +fieldId)
      .filter((id) => fields.ids.includes(id))
  }, [fieldRelationships, fieldId])

  const fieldRelationshipIds = useMemo(() => {
    return Object.values(fieldRelationships || {}).map((fieldRelationshipId) => +fieldRelationshipId)
  }, [fieldRelationships])

  return (
    <OptionsRelationshipsContext.Provider
      value={{
        editingOption,
        setEditingOption,
        showViewRelationshipsPopover,
        setShowViewRelationshipsPopover,
        showManageRelationshipsPopover,
        setShowManageRelationshipsPopover,
        fields,
        relatedFieldIds,
        fieldRelationshipIds,
        fieldRelationships,
        options,
        updateOption,
        removeOption,
        optionRelationships,
        manageSelectOptionRelationship
      }}
    >
      {children}
    </OptionsRelationshipsContext.Provider>
  )
}

export const useSelectOptionsContext = () => {
  const context = useContext(OptionsRelationshipsContext)

  if (!context) {
    throw new Error('useOptionsRelationships must be used with an OptionsRelationshipsProvider')
  }

  return context
}
